// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__faPrB","inner":"styles_inner__aApSf","title":"styles_title__g_Ijk"};